import { GiveawayQuestion } from '@/fairplayer/domain/giveaway/GiveawayQuestion';
import { fromGiveawayAnswer, GiveawayAnswerUi } from '@/fairplayer/primary/club/GiveawayAnswer.ui';
import { renderMarkdown } from '@/common/primary/MarkdownRenderer';
import { MarkdownUi } from '@/common/primary/Markdown.ui';

export interface GiveawayQuestionUi {
  id: string;
  title: string;
  preTitle?: MarkdownUi;
  answers: GiveawayAnswerUi[];
  required: boolean;
  multiline: boolean;
}

export const fromGiveawayQuestion = (giveawayQuestion: GiveawayQuestion): GiveawayQuestionUi => ({
  id: giveawayQuestion.id,
  title: giveawayQuestion.title,
  preTitle: giveawayQuestion.preTitle.map(renderMarkdown).orElseUndefined(),
  answers: giveawayQuestion.answers.map(fromGiveawayAnswer),
  required: giveawayQuestion.required,
  multiline: giveawayQuestion.multiline,
});
